interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  centered?: boolean;
  accent?: boolean;
  as?: 'h1' | 'h2' | 'h3';
}

export default function SectionHeading({ title, subtitle, centered = true, accent = true, as: Tag = 'h2' }: SectionHeadingProps) {
  return (
    <div className={`mb-10 ${centered ? 'text-center' : ''}`}>
      <Tag className="text-2xl md:text-3xl font-bold text-gray-900 tracking-tight">
        {title}
      </Tag>
      {accent && (
        <div className={`mt-3 h-1 w-16 bg-primary rounded ${centered ? 'mx-auto' : ''}`} />
      )}
      {subtitle && (
        <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto">
          {subtitle}
        </p>
      )}
    </div>
  );
}
